import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div id="sidebar" style="position: absolute;">
  <h3 class="mb-14">
   <a (click)="isLogin()">
     AGADIDEVIN
   </a>
  </h3>
  <p><a href="#">About</a></p>
  <p><a href="#">Work</a></p>
  <p><a href="#">Course</a></p>
  <p><a href="#">Web Me AI</a></p>
  <p><a href="#">Link</a></p>
  <p style="margin-bottom: 0;">
      <button *ngIf="isLoagin" class="btn btn-outline-danger w-full">
        <span *ngIf="!token">Login</span>
        <span *ngIf="token">LogOut</span>
      </button>
  </p>

</div>
  `,
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() getActiveSidebar: any;
  isLoagin = false;
  token!: string | null;
  constructor(private router: Router) { }

  ngOnInit(): void {
    if(this.getActiveSidebar){
      console.log('getActiveSidebar' ,this.getActiveSidebar)
    }
    this.token = localStorage.getItem('token')
  }
  isLogin(){
  this.isLoagin = !this.isLoagin
  }
  logout(){
    localStorage.removeItem('token')
    localStorage.removeItem('username')
    localStorage.clear()
  }


}
